module.exports = __webpack_public_path__ + "@/assets/img/google_play.637b5356.png";